import styles from './RateCard.module.scss';
import {
	EquipmentModifierPanel,
	TailgateLiftModifierPanel,
	HandUnloadModifierPanel,
	SplitTrailerModifierPanel,
	WeekendAndHolidaysModifierPanel,
	TrailerTypeModifierPanel,
	// TimeframeModifierPanel,
	AdditionalStopsModifierPanel,
	DGModifierPanel,
	OtherModifierPanel,
	AdminBookingFeesPanel,
	TimeSlotModifierPanel
} from '../RC_Modifiers';
import { DEFAULT_RATE_CARD_RANGES, SettingType } from '@types';

type TProps = {
	settingType: SettingType;
	type: keyof typeof DEFAULT_RATE_CARD_RANGES;
	isDisabled?: boolean;
	itemTypeId?: string;
}

export const RateCardModifiers = ({ settingType, type, isDisabled = false, itemTypeId }: TProps) => {
	return (
		<div className={styles.expanders}>
			<EquipmentModifierPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			<TailgateLiftModifierPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			<HandUnloadModifierPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			<SplitTrailerModifierPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			<DGModifierPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			{/* <TimeframeModifierPanel type={type} isDisabled={isDisabled} /> */}
			<AdditionalStopsModifierPanel stopType={'PICKUP'} type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			<AdditionalStopsModifierPanel stopType={'DROPOFF'} type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			<WeekendAndHolidaysModifierPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			<TrailerTypeModifierPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			{
				settingType !== 'Carrier' && <AdminBookingFeesPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			}
			<TimeSlotModifierPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
			<OtherModifierPanel type={type} isDisabled={isDisabled} itemTypeId={itemTypeId} />
		</div>
	);
}
